import React from "react";
import {
  Footer,
  // FooterBrand,
  FooterCopyright,
  FooterDivider,
  FooterIcon,
  FooterLink,
  FooterLinkGroup,
  FooterTitle,
} from "flowbite-react";
import { BsDribbble, BsFacebook, BsGithub, BsInstagram, BsTwitter, BsTelephone, BsGeoAlt } from "react-icons/bs";
import img from '../Assets/aryaa_logo.png';

function FooterComponent() {
  return (

    <Footer container={true} className="w-full bg-yellow-50">
      <div className="w-full">
        <div className="flex flex-wrap justify-between relative">
          <div className="flex-1 min-w-[300px] md:max-w-[300px] text-left sm:pr-5 relative section-with-line">
            {/* <div className="absolute top-[0px] left-[400px] [background:linear-gradient(180deg,_rgba(171,_174,_183,_0),_rgba(20,_20,_20,_0.8)_51.56%,_rgba(171,_174,_183,_0))] w-px h-[155.7px]" /> */}
            <div className="inline-block">
              <a href="https://aryaafood.com/" className="inline-block">
                <img
                  className="inline-block max-w-24"
                  src={img}
                  alt="Aryaa Foods"
                  title="Aryaa Foods"
                />
              </a>
              {/* <p className="inline-block ml-2 text-accent font-primary text-[32px]">Aryaa Foods</p> */}
            </div>
            <h3 className="footetext text-left text-[14px] text-[#6d7482] ">
              Take a look at how we designed this house. Simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.
            </h3>
          </div>

          <div className="flex-1 min-w-[200px] sm:min-w-[100px] sm:max-w-[140px] md:max-w-[200px] lg:max-w-[300px] lg:text-center  relative section-with-line sm:mt-3">
            {/* <div className="absolute top-[0px] left-[400px] [background:linear-gradient(180deg,_rgba(171,_174,_183,_0),_rgba(20,_20,_20,_0.8)_51.56%,_rgba(171,_174,_183,_0))] w-px h-[155.7px]" /> */}
            <FooterTitle className="font-primary text-accent text-[32px] " title="Pages" />
            <FooterLinkGroup className="lg:leading-loose sm:leading-loose text-left  inline-block">
              <FooterLink href="#">HOME</FooterLink>
              <FooterLink href="#">ABOUT US</FooterLink>
              <FooterLink href="#">OUR PRODUCTS</FooterLink>
              <FooterLink href="#">CONTACT</FooterLink>
            </FooterLinkGroup>
          </div>

          <div className="flex-1 sm:min-w-[180px] md:min-w-[300px] md:max-w-[300px] lg:max-w-[400px] text-left relative section-with-line flex flex-col justify-center sm:mt-3">
            <div className="vist sm:mb-2 md:mb-8 flex flex-col md:flex-row items-center">
              <FooterTitle className="font-primary text-accent text-[30px] lg:text-[40px] sm:m-2 md:mr-4" title="Visit" />
              <FooterLinkGroup col>
                <FooterLink>
                  <BsGeoAlt className="inline-block mr-4 text-accent " />
                  Logan Barker, 865 Oak Boulevard, Elk Grove, Vermont 95184
                </FooterLink>
              </FooterLinkGroup>
            </div>
            <div className="call mb-8 flex flex-col md:flex-row items-center">
              <FooterTitle className="font-primary text-accent  text-[30px] lg:text-[40px] sm:m-2 md:mr-7" title="Call" />
              <FooterLinkGroup col>
                <FooterLink>
                  <BsTelephone className="inline-block mr-4  text-accent" />
                  +971 6 74 87 538
                </FooterLink>
              </FooterLinkGroup>
            </div>
          </div>


          <div className="flex-1 min-w-[200px] pl-10  text-center hidden md:block lg:hidden xl:block relative  section-with-line">
            {/* <FooterTitle className="font-primary text-accent text-[32px] pb-1" title="Social Media" /> */}
            <FooterLinkGroup className="leading-big inline-block">
              <div className="footerspc flex items-center space-y-1">
                <a href="#" className="flex items-center space-x-4">
                  <FooterIcon icon={BsFacebook} />
                  <h4 className="ml-1">FaceBook</h4>
                </a>
              </div>
              <div className="footerspc flex items-center space-x-1">
                <a href="#" className="flex items-center space-x-4">
                  <FooterIcon icon={BsInstagram} />
                  <h4 className="ml-1">Instagram</h4>
                </a>
              </div>
              <div className="footerspc flex items-center space-x-1">
                <a href="#" className="flex items-center space-x-4">
                  <FooterIcon icon={BsTwitter} />
                  <h4 className="ml-1">Twitter</h4>
                </a>
              </div>
              <div className="footerspc flex items-center space-x-1">
                <a href="#" className="flex items-center space-x-4">
                  <FooterIcon icon={BsGithub} />
                  <h4 className="ml-1">GitHub</h4>
                </a>
              </div>
              <div className="footerspc flex items-center space-x-1">
                <a href="#" className="flex items-center space-x-4">
                  <FooterIcon icon={BsDribbble} />
                  <h4 className="ml-1">Dribbble</h4>
                </a>
              </div>
            </FooterLinkGroup>
          </div>

        </div>
        <FooterDivider className="m-2" />
        <div className="w-full sm:flex sm:items-center sm:justify-between">
          <FooterCopyright href="#" by="Aryaa Foods™" year={2024} />
          <div className="mt-3 flex space-x-2 sm:mt-0 sm:justify-center md:hidden sm:display lg:flex xl:hidden" >
            <FooterIcon href="#" icon={BsFacebook} />
            <FooterIcon href="#" icon={BsInstagram} />
            <FooterIcon href="#" icon={BsTwitter} />
            <FooterIcon href="#" icon={BsGithub} />
            <FooterIcon href="#" icon={BsDribbble} />
          </div>
        </div>
      </div>
    </Footer>
  );
}

export default FooterComponent;
